/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Account')
    .controller('NotificationShareModalController', ['$scope', '$modalInstance', 'share', 'operationComplete', 'AccountNotificationsShares',
        function($scope, $modalInstance, share, operationComplete, AccountNotificationsShares) {
            $scope.modal =  $modalInstance.options;
            $scope.share = angular.copy(share);

            if (!$scope.share.notification) {
                $scope.modal.loading = true;
                AccountNotificationsShares.get({uuid: $scope.share.uuid}, {}, function(share){
                    $scope.share = share;
                    $scope.modal.loading = false;
                });
            }

            $scope.applyDefaultsToShare = function() {
                $scope.share.notification = angular.copy($scope.account.notificationDefault);
                $scope.share.use_defaults = true;
            };

            $scope.applyCustomShare = function() {
                $scope.share.use_defaults = false;
            };

            $scope.updateShareNotifications = function() {
              $scope.share.notification.node_uuid = $scope.share.node_uuid;
              $scope.share.notification.use_defaults = $scope.share.use_defaults ? "t" : "f";
              $scope.share.$save({}, function(){
                  operationComplete('Successfully saved notification settings.');
                  $modalInstance.close('reload_shares');
              });
            };

            $scope.ok = function () {
                $scope.updateShareNotifications();
            };

            $scope.cancel = $scope.close = function () {
                $modalInstance.dismiss();
            };
        }]);
 
 
